import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, IconButton, Box } from "@mui/material";
import ArrowUp from '../../assets/caret-up-fill.svg';
const ImageDialog = ({ open, onClose, images, startIndex = 0 }) => {
    const [currentIndex, setCurrentIndex] = useState(startIndex);
    useEffect(() => {
        if (open) {
            setCurrentIndex(startIndex);
        }
    }, [open, startIndex]);
    const handlePrev = () => {
        setCurrentIndex((prev) => prev === 0 ? images.length - 1 : prev - 1);
    };
    const handleNext = () => {
        setCurrentIndex((prev) => prev === images.length - 1 ? 0 : prev + 1);
    };
    return (_jsx(Dialog, { open: open, onClose: onClose, maxWidth: "xl", fullWidth: true, children: _jsx(DialogContent, { sx: { position: "relative", p: 0 }, onClick: e => e.stopPropagation(), children: _jsxs(Box, { sx: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    maxHeight: "90vh",
                    overflow: "hidden",
                    position: "relative",
                    backgroundColor: 'dimgray'
                }, children: [_jsx("img", { src: images[currentIndex], alt: `image-${currentIndex}`, style: {
                            maxWidth: "100%",
                            maxHeight: "90vh",
                            objectFit: "contain"
                        } }), images.length > 1 && (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: handlePrev, sx: {
                                    position: "absolute",
                                    left: 8,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    backgroundColor: "rgba(0,0,0,0.4)",
                                    color: "white"
                                }, children: _jsx(ArrowUp, { style: { transform: 'rotate(270deg)' } }) }), _jsx(IconButton, { onClick: handleNext, sx: {
                                    position: "absolute",
                                    right: 8,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    backgroundColor: "rgba(0,0,0,0.4)",
                                    color: "white"
                                }, children: _jsx(ArrowUp, { style: { transform: 'rotate(90deg)' } }) })] }))] }) }) }));
};
export default ImageDialog;
